const TZ_SUFFIX_REGEX = /(z|[+-]\d{2}:?\d{2})$/i

const normalizeUtcInput = (value: string): string => {
  const trimmed = value.trim()
  if (!trimmed) return trimmed

  const normalized = trimmed.includes('T') ? trimmed : trimmed.replace(' ', 'T')

  return TZ_SUFFIX_REGEX.test(normalized) ? normalized : `${normalized}Z`
}

const pad = (part: number): string => String(part).padStart(2, '0')

export const parseUtcDate = (value?: string): Date | null => {
  if (!value) return null

  const normalized = normalizeUtcInput(value)
  const parsed = new Date(normalized)
  if (!Number.isNaN(parsed.getTime())) return parsed

  const fallback = new Date(value)
  return Number.isNaN(fallback.getTime()) ? null : fallback
}

export const toDateTimeLocalValue = (date: Date): string => {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export const utcToLocalDateTimeInputValue = (value?: string): string => {
  const parsed = parseUtcDate(value)
  if (!parsed) return value ? value.slice(0, 16) : ''

  return toDateTimeLocalValue(parsed)
}

export const localInputToUtcIsoString = (value?: string): string => {
  if (!value) return ''

  const parsed = new Date(value)
  return Number.isNaN(parsed.getTime()) ? value : parsed.toISOString()
}

export const utcToLocalDisplay = (value?: string): string => {
  const parsed = parseUtcDate(value)
  return parsed ? parsed.toLocaleString() : value || ''
}
